import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Subfooter from './Subfooter';

const Investment = () => {
    useEffect(() =>{
        document.title = "Investment | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="investmentbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Investment</h3>
        <p className='description hmfirstboxdescription'>
            
        We focus on delivering alternative investment options to investors <br/> seeking long term financial growth and a  diversified portfolio. <br/> We partner with individuals and institutions to achieve their  <br/>financial goals
        
        </p>
        
        <p class="centermobile">
        <a href="#learnmore"><button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button></a>
        {/* <h4 className="hmbuttons hmvot">View our team <img src="images/arrow_forward.png"/></h4> */}
        </p>

  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox' id="learnmore">
 
    </div>


    <div className='hmthirdbox'>
    <div className=''>
        {/* <Container> */}
            <Row>
                <div className='col-lg-6 col-md-12'>
                {/* <img style={{width:"100%"}} src="images/whoweare.png"/>  */}
                <iframe class="youtube-video"  src="https://www.youtube.com/embed/0MPfW7_C99U" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>         
                
                
                           </div>

                    {/* <div className='col-md-1'></div> */}

                    <div className='col-lg-5 col-md-12'>
                    <h1 className="hmwwd">How Rich-Oak decides<br/> on businesses for<br/> <span style={{color:"#D80032"}}> investors</span></h1>
                    {/* <hr class="hpwwdhr1"/> */}
                    <p  className="hmwwdp"></p>
               
                    <p className='hmsecondboxdescription'>
                    "We adopted a framework for assessing risk that has been incredibly reliable. We created an investment committee to distill every individual investment opportunity down to two or three major variables that will define the success of our investment case and create value. This investment committee is about discussion, risk assessment and discovery."
                         </p>
                    </div>

                    {/* <div className='col-md-5 formobileonly'>
                <iframe className="img-fluid hmytvideo" width="560" height="415" src="https://www.youtube.com/embed/sWVVazhSFuE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div> */}

               
                
            </Row>
        {/* </Container> */}
        </div>
    </div>




 <div className='hmfourthbox'>
    <div className=''>

            <Row>
                <div className='col-lg-5 col-md-4'>
        <p className='hmcia'>What 
       <span style={{color:"#D80032"}} > We </span> 
        Do
        </p>

        {/* <p className='hmcia formobileonly'>C
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p> */}
        <p  className="hmwwdp"></p>
        <img class="blogmobile" style={{width:"100%"}} src="images/whatwedo.jpeg"/> 
                    </div>
                    <div className='col-lg-1 col-md-1'></div>

                    <div className='col-lg-5 col-md-6'>
                  
                       {/* <img class="img-fluid" src="images/credit.png"/> */}
                       <div class="divinvestments">
                        <p className="hmciahead">Diversified Investments</p>
                        <p  className='hmfourthboxinner'>
                        Rich-Oak invests in Credit, Real Estate, Agriculture and Private Equity. Exposing our investors to more opportunities for returns and allowing them enjoy the benefits of a diversified portfolio.                       
                            </p>
                            </div>

                            <div class="divinvestments2">
                            <p className="hmciahead">Financial Advisory</p>
                        <p  className='hmfourthboxinner'>
                        We stand apart by offering our partners a clear strategy for growth. We provide advisory solutions to help them maximize the funds they have, in-other to create the best impact for their businesses. We provide the businesses we partner with, advisory services backed by facts and figures as we study moving market  trends in each specific industry, this has helped our partners achieve stunning profits over the years.                         
                            </p>
                            </div>

                            <div class="divinvestments3">
                            <p className="hmciahead">Fund Management</p>
                        <p  className='hmfourthboxinner'>
                        We scout and capture great Investment opportunities for our partners. As businesses turn over huge amounts of profits, we come in to invest these funds into vehicles that offers attractive risk adjusted returns, increasing our clients total profit turn over and asset portfolio.                        
                            </p>
                            </div>
                    </div>

        

                 
               
               
                
            </Row>

     
   
        </div>
    </div> 

    <Row>
            <div className='col-md-12'>
            <p className="whatwedohead">Industries we invest in</p>
           <hr class="whatwedohr"/>
            {/* <p className="whatwedobody">We invest on behalf of private individuals and institutions across different alternative <br/>investment asset classes in order to achieve thier investment goals</p> */}
            </div>
        </Row>
     
     <Container>
     <div class="row realestatebox">
                <div className='col-md-6 hideipad'>
                <img class="img-fluids"src="images/4.jpeg"/> 
                    </div>


                    <div className='col-lg-6 col-md-12 realestate3'>
                    <h1 className="hmwwd realestatehead">Real estate</h1>
               
                    <p className='hmsecondboxdescription'>
                        
                    We offer a range of real estate services where individuals can invest in our real estate fund to enjoy good returns and also own properties with a flexible plan. Our real estate business provides competitive ROI for our investors and we are expanding to offer even more robust real estate services
                         
                         </p>
                         <p class="centermobile">
                             <button className='hmfirstboxbuttonrealestate hmbuttons'>LEARN MORE</button>
                             </p>

                    </div>
</div>

              <div class="row realestatebox2">       

              <div className='col-md-6 formobileonly'>
                <img class="img-fluid" src="images/5.jpg"/> 
                    </div>
                    <div className='col-lg-6 col-md-12 realestate3'>
                    <h3 className="hmwwd realestatehead">Credit</h3>
               
                    <p className='hmsecondboxdescription'>
                    We have been investing in credit since 2016, from offering consumer loans, we have expanded to serve Visa Financing, LPO's and SME/Business funding.
                         
                         </p>
                         <p class="centermobile">
                         <button className='hmfirstboxbuttonrealestate2 hmbuttons'>LEARN MORE</button>
</p>
                    </div>

                    <div className='col-md-6 fordesktoponly hideipad'>
                <img  class="img-fluid" src="images/5.jpg"/> 
                    </div>
                    </div>

                    {/* <div class="row realestatebox2">     
                    <div className='col-md-6 hideipad'>
                <img  class="img-fluids hideipad" src="images/agric.png"/> 
                    </div>


                    <div className='col-lg-6 col-md-12 realestate3'>
                    <h1 className="hmwwd realestatehead">Agriculture</h1>
               
                    <p className='hmsecondboxdescription'>Rich-Oak Group is a financial institution building reliable financial partnerships with individuals and institutions through professionalism, 
                        innovation and providing premium value. Our vision is to be Africa's most reliable financial partner. 
.</p>
                         <p class="centermobile">
                         <button className='hmfirstboxbuttonrealestate2 hmbuttons'>LEARN MORE</button>
</p>
                    </div>
                    </div> */}
                    </Container>
              

                    <Subfooter/>


    </div>

<div id="homepagethirdbox">
    

</div>






    <Footer/>
    </div>


    )
    
    
}


export {Investment as default}